'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFastTrackToken = exports.getFastTrackSid = exports.uploadFile = exports.getProtected = exports.postProtected = exports.get = exports.post = exports.fetchJSON = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _player = require('./player');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHost() {
  if (typeof global !== 'undefined' && global.middlemanHost) return global.middlemanHost;
  if (typeof window !== 'undefined' && window.middlemanHost) return window.middlemanHost;
  return 'https://tg-middleman.herokuapp.com';
}

function NetworkException(data) {
  this.value = data;
  this.isNetworkException = true;
}

var fetchJSON = exports.fetchJSON = function fetchJSON(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return (0, _axios2.default)(_extends({
    url: '' + getHost() + url
  }, options)).catch(function (error) {
    try {
      var errorJson = JSON.parse(error);
      throw new NetworkException(errorJson);
    } catch (err) {
      throw new NetworkException(error);
    }
  });
};

var post = exports.post = function post(url, data) {
  return fetchJSON(url, {
    method: 'POST',
    data: data
  });
};

var get = exports.get = function get(url) {
  return fetchJSON(url);
};

var postProtected = exports.postProtected = function postProtected(url, playerSessionID, data) {
  return fetchJSON(url, {
    method: 'POST',
    headers: {
      'X-Player-Session-Id': playerSessionID
    },
    data: data
  });
};

var getProtected = exports.getProtected = function getProtected(url, playerSessionID) {
  return fetchJSON(url, {
    headers: {
      'X-Player-Session-Id': playerSessionID
    }
  });
};

var uploadFile = exports.uploadFile = function uploadFile(url, body, playerSessionID) {
  return (0, _axios2.default)({
    url: '' + getHost() + url,
    headers: {
      'X-Player-Session-Id': playerSessionID,
      'Content-Type': 'application/json'
    },
    method: 'POST',
    data: body
  });
};

var getFastTrackSid = exports.getFastTrackSid = function getFastTrackSid(sessionId) {
  return new Promise(function (resolve, reject) {
    var g = window || global || {};
    if (!g._ftSid) {
      (0, _player.createSSOToken)(sessionId, 'FastTrack').then(function (sid) {
        if (sid.status !== 200) {
          console.error('Error', sid);
          return reject();
        }

        g.sid = g._ftSid = sid.data;

        return resolve(g._ftSid);
      });
    } else {
      return resolve(g._ftSid);
    }
  });
};

var getFastTrackToken = exports.getFastTrackToken = function getFastTrackToken(authtoken) {
  return new Promise(function (resolve, reject) {
    var g = window || global || {};
    if (!g._ftToken) {
      (0, _axios2.default)({
        method: 'post',
        url: g.fastTrackAPIHost + '/Platform/LoginAuthToken',
        headers: {
          authtoken: authtoken
        }
      }).then(function (tokenRes) {
        if (!tokenRes.data.Success) {
          console.error('Error', tokenRes);
          return reject();
        }

        g._ftToken = tokenRes.data.Data.Authentication.AuthToken;
        return resolve(g._ftToken);
      });
    } else {
      return resolve(g._ftToken);
    }
  });
};